import { combineReducers } from "redux";
import { makeRequestReducer } from "../utils";
import { types } from "@authzsvc/api-lib";

export default combineReducers({
  getApplicationList: makeRequestReducer(types.GET_APPLICATION_LIST),
  deleteApplication: makeRequestReducer(types.DELETE_APPLICATION),
  addApplication: makeRequestReducer(types.ADD_APPLICATION),
  getApplication: makeRequestReducer(types.GET_APPLICATION),
  getApplicationRoles: makeRequestReducer(types.GET_ROLES),
  getRegistrations: makeRequestReducer(types.GET_REGISTRATIONS),
  getGroups: makeRequestReducer(types.GET_MY_GROUPS),
  getRoleForApplication: makeRequestReducer(types.GET_ROLE_FOR_APPLICATION),
  registerApplication: makeRequestReducer(types.REGISTER_APPLICATION),
  deleteRegistration: makeRequestReducer(types.DELETE_REGISTRATION),
  getMyRequests: makeRequestReducer(types.GET_REQUESTS),
  getRequestsToApprove: makeRequestReducer(types.GET_REQUESTS_TO_APPROVE),
  cancelRequest: makeRequestReducer(types.CANCEL_REQUEST),
  denyRequest: makeRequestReducer(types.DENY_REQUEST),
  approveRequest: makeRequestReducer(types.APPROVE_REQUEST),
  getLevelsOfAssurance: makeRequestReducer(types.GET_LEVELS_OF_ASSURANCE),
  resolveIdentity: makeRequestReducer(types.RESOLVE_IDENTITY),
  getGroupsForApplication: makeRequestReducer(types.GET_IDENTITY_MEMBERSHIPS),
  getApplicationListMultipleFieldsV2: makeRequestReducer(
    types.GET_APPLICATION_LIST_V2,
  ),
  getAllApplicationsV2: makeRequestReducer(types.GET_ALL_APPLICATIONS_V2),
});
